import request from './request';

export const fetchBrands = () =>
  request({
    method: 'GET',
    url: '/clients/brands',
    protectedRoute: true,
    newApi: true
  });
